export const lightThemeTokens = {
  // Temanın ana vurgu rengi, butonlar, linkler, seçili durumlar için kullanılır
  colorPrimary: "	#64748B",

  // Köşelerin yuvarlaklık derecesi (px)
  borderRadius: 3,

  // Kart, panel gibi içerik bloklarının arka plan rengi (beyaz)
  colorBgContainer: "#fff",

  // Genel sayfa arka plan rengi, açık gri tonlarında
  colorBgBase: "#f7f8fa",

  // Temel metin rengi, koyu ve okunabilir
  colorText: "#23232b",

  // Kenarlık ve bölme çizgileri için açık gri ton
  colorBorder: "#d9d9d9",

  // Kart ve popup gibi bileşenlerde kullanılan hafif gölge efekti
  boxShadow: "0 2px 8px rgba(185, 34, 34, 0.09)",

  // Sayfa düzeninin (layout) arka plan rengi, açık gri tonunda
  colorBgLayout: "#f0f2f5",

  // --- Header (üst bar) renkleri ---

  // Üst bar arka plan rengi, sayfa düzeniyle uyumlu açık gri
  colorHeaderBg: "#f0f2f5",

  // Üst bar içindeki metin ve ikon rengi, koyu ve okunabilir
  colorHeaderText: "#23232b",
};

export const darkThemeTokens = {
  // Temanın ana vurgu rengi, açık temayla aynı renk
  colorPrimary: "#64748B",

  // Köşelerin yuvarlaklık derecesi (px)
  borderRadius: 3,

  // İçerik bloklarının koyu arka plan rengi, siyahımsı tonlarda
  colorBgContainer: "#181A1B",

  // Genel sayfa arka planı, koyu siyah tonunda
  colorBgBase: "#141414",

  // Temel metin rengi, açık ve kontrastlı (beyaz)
  colorText: "#fff",

  // Koyu temada kenarlıklar için koyu gri ton
  colorBorder: "#444",

  // Koyu temada derin gölge efekti, daha belirgin
  boxShadow: "0 4px 12px rgba(0,0,0,0.75)",

  // Sayfa düzeninin koyu arka plan rengi
  colorBgLayout: "#121212",

  // --- Header (üst bar) renkleri ---

  // Koyu temada üst bar arka plan rengi, koyu gri-mavi tonlu
  colorHeaderBg: "#22272b",

  // Koyu temada üst bar metin ve ikon rengi, açık ve okunaklı (beyaz)
  colorHeaderText: "#fff",

};
